"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _NativeOption = require("./NativeOption");
var _CustomOption = require("./CustomOption");
var _excluded = ["children", "value", "key", "disabled", "isDesktopView"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Option = function Option(_ref) {
  var children = _ref.children,
    value = _ref.value,
    key = _ref.key,
    disabled = _ref.disabled,
    _ref$isDesktopView = _ref.isDesktopView,
    isDesktopView = _ref$isDesktopView === void 0 ? false : _ref$isDesktopView,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (isDesktopView || !(0, _utils.isMobile)()) {
    return /*#__PURE__*/_react.default.createElement(_CustomOption.CustomOption, _extends({
      children: children,
      key: key,
      disabled: disabled
    }, otherProps));
  }
  return /*#__PURE__*/_react.default.createElement(_NativeOption.NativeOption, _extends({
    children: children,
    value: value,
    key: key,
    disabled: disabled
  }, otherProps));
};
exports.Option = Option;